export const MAX_CHANNELS = 6;
export const DEFAULT_OVERVIEW = {
  margin: 25,
  scale: 0.15,
  position: 'bottom-left'
};
export const COLORMAP_OPTIONS = [
  'viridis',
  'greys',
  'magma',
  'jet',
  'hot',
  'bone',
  'copper',
  'summer',
  'density',
  'inferno'
];
export const COLOR_PALLETE = [
  [0, 0, 255],
  [0, 255, 0],
  [255, 0, 255],
  [255, 255, 0],
  [255, 128, 0],
  [0, 255, 255],
  [255, 255, 255],
  [255, 0, 0]
];
export const GLOBAL_SLIDER_DIMENSION_FIELDS = ['z', 't'];
export const INITIAL_SLIDER_VALUE = [1500, 20000];
export const FILL_PIXEL_VALUE = '----';
